import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { FormSection } from "./FormSection";
import { DSelect, HInput } from "../../../../validation/HForm";

const IndustrySection = ({ questionNumber }) => {
  const { control } = useFormContext();

  const { debtLoadGroup, loading } = useSelector(({ debtLoad }) => debtLoad);

  return (
    <FormSection
      questionNumber={questionNumber}
      title="Вид деятельности, профессия клиента"
      className="entry-wrapper industry"
    >
      <Controller
        name="employmentIndustry"
        control={control}
        render={({ field }) => (
          <div>
            <DSelect
              name="employmentIndustry"
              placeholder="Выберите отрасль"
              options={debtLoadGroup.map((industry) => ({
                label: industry.name,
                value: industry.value,
              }))}
              noOptionsMessage={() => "Нет результатов"}
              isLoading={loading}
              loadingMessage={() => "Загрузка..."}
              styles={{
                menuList: (base) => ({
                  ...base,
                  padding: 0,
                  maxHeight: '165px',
                }),
              }}
              menuShouldScrollIntoView={false}
              isClearable
              isSearchable
            />
            <HInput
              h="true"
              type="hidden"
              name="monthlyIncomeIndustry"
            />
          </div>
        )}
      />
    </FormSection>
  );
};

export default IndustrySection;
